import { render, staticRenderFns } from "./1BeforeYouTravel.vue?vue&type=template&id=5ec95d83"
import script from "./1BeforeYouTravel.vue?vue&type=script&lang=js"
export * from "./1BeforeYouTravel.vue?vue&type=script&lang=js"
import style0 from "./1BeforeYouTravel.vue?vue&type=style&index=0&id=5ec95d83&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports